var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16687 6.66234C1.27626 6.66249 1.3846 6.64097 1.48564 6.59904C1.58667 6.5571 1.6784 6.49557 1.75553 6.418L6.0166 2.15748C6.14552 2.02852 6.29859 1.92623 6.46705 1.85643C6.63551 1.78664 6.81608 1.75072 6.99843 1.75072C7.18078 1.75072 7.36134 1.78664 7.5298 1.85643C7.69827 1.92623 7.85133 2.02852 7.98026 2.15748L12.2347 6.41244C12.3115 6.492 12.4034 6.55546 12.5051 6.59912C12.6067 6.64278 12.716 6.66576 12.8266 6.66672C12.9372 6.66768 13.0469 6.6466 13.1493 6.60472C13.2516 6.56283 13.3446 6.50098 13.4228 6.42277C13.5011 6.34456 13.5629 6.25155 13.6048 6.14918C13.6467 6.0468 13.6678 5.93712 13.6668 5.82651C13.6658 5.71591 13.6429 5.6066 13.5992 5.50497C13.5555 5.40334 13.4921 5.31142 13.4125 5.23458L9.15812 0.97962C8.58496 0.407531 7.80824 0.0862241 6.99843 0.0862241C6.18862 0.0862241 5.41189 0.407531 4.83874 0.97962L0.577665 5.24013C0.461092 5.35663 0.381696 5.50509 0.349523 5.66673C0.31735 5.82837 0.333847 5.99591 0.396926 6.14817C0.460005 6.30043 0.566831 6.43055 0.703886 6.52208C0.840942 6.6136 1.00207 6.66242 1.16687 6.66234Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClose);
export default __webpack_public_path__ + "static/media/arrowClose.4f49bf8e718c4140e8921cef56353a28.svg";
export { ForwardRef as ReactComponent };